import { cloneElement, JSX } from 'react';
import { Box, CircularProgress, HStack, VStack } from '@chakra-ui/react';
import { SectionTitle } from '../atoms/Title.tsx';
import { useTheme } from '../../contexts/ThemeProvider.tsx';

export function ReportDataCard({
  icon,
  value,
  label,
  formatter = (value) => value,
  isLoading = false,
}: {
  icon: JSX.Element;
  value: any;
  label: string;
  formatter?: (value: string) => string;
  isLoading?: boolean;
}) {
  const { colors } = useTheme();

  return (
    <VStack width={'100%'} height={'90px'} position={'relative'}>
      <Box
        zIndex={0}
        width={'100%'}
        height={'100%'}
        borderRadius={'4px'}
        backgroundColor={'secondaryColor'}
        boxShadow={'0px 0px 5px rgba(0,0,0, 0.2)'}
        position={'absolute'}
        opacity={0.5}
      ></Box>
      <VStack padding={'15px 20px'} align={'flex-start'} width={'100%'} spacing={4} zIndex={1}>
        <SectionTitle
          color={'secondaryFontColor'}
          height={'10px'}
          textTransform="none"
          fontSize={'10pt'}
          fontWeight={500}
        >
          {label}
        </SectionTitle>
        <HStack align={'flex-end'} width={'100%'} spacing={5} justify={'space-between'}>
          {!isLoading && value != null && (
            <SectionTitle color={'secondaryFontColor'} fontSize={21}>
              {formatter(value)}
            </SectionTitle>
          )}
          {isLoading && <CircularProgress size={'18pt'} color={'black'} isIndeterminate />}
          {cloneElement(icon, { size: '24pt', color: colors.secondaryColor })}
        </HStack>
      </VStack>
    </VStack>
  );
}

export function BigReportDataCard({
  icon,
  value,
  label,
  formatter = (value) => value,
  isLoading = false,
}: {
  icon: JSX.Element;
  value: any;
  label: string;
  formatter?: (value: string) => string;
  isLoading?: boolean;
}) {
  const { colors } = useTheme();

  return (
    <VStack width={'100%'} position={'relative'}>
      <Box
        zIndex={0}
        width={'100%'}
        height={'100%'}
        borderRadius={'4px'}
        backgroundColor={'secondaryColor'}
        boxShadow={'0px 0px 5px rgba(0,0,0, 0.2)'}
        position={'absolute'}
        opacity={0.5}
      ></Box>
      <VStack padding={'15px 20px'} align={'flex-start'} width={'100%'} spacing="50px" zIndex={1}>
        <SectionTitle
          color={'secondaryFontColor'}
          height={'10px'}
          textTransform="none"
          fontSize={'12pt'}
          fontWeight={500}
        >
          {label}
        </SectionTitle>
        <VStack spacing={10} width={'100%'}>
          {cloneElement(icon, { size: '80pt', color: colors.secondaryColor })}
          {!isLoading && value != null && (
            <SectionTitle color={'secondaryFontColor'} fontSize={30}>
              {formatter(value)}
            </SectionTitle>
          )}
          {isLoading && <CircularProgress size={'21pt'} color={'black'} isIndeterminate />}
        </VStack>
      </VStack>
    </VStack>
  );
}
